// extracted by mini-css-extract-plugin
export default {"ColorContainer":"Color_ColorContainer__kXlWX","ColorSelector":"Color_ColorSelector__5n0PL","ColorCloser":"Color_ColorCloser__2eOTb"};